import qs from 'qs';

import { isIOS } from '@eaphone/env';
import { Network } from '@eaphone/network/next.ts';
import { captureException } from '@eaphone/sentry';

import { wxsdk } from './api.ts';

async function getSignature(url: string) {
  return Network.custom.get('passport/v1/wxmp/signature', {
    auth: false,
    searchParams: { url, appid: import.meta.env.APP_ID },
  });
}

const initUrl = document.URL;

function removeCode(url: string) {
  const [path, query] = url.split('?');

  if (query) {
    const { code, state, ...rest } = qs.parse(query);

    return [path, qs.stringify(rest)].filter(Boolean).join('?');
  }

  return path || '/';
}

export type ConfigParameter = Parameters<(typeof wxsdk)['config']>[0];

export function wxConfig({ openTagList, jsApiList }: Partial<ConfigParameter>) {
  const entryUrl = isIOS ? removeCode(initUrl) : document.URL;

  return getSignature(entryUrl)
    .then((data) => {
      wxsdk.config({
        // debug: true,
        openTagList,
        jsApiList,
        ...data,
      });
    })
    .catch((error) => {
      captureException(error, {
        tags: { scene: 'getSignature' },
      });
      throw error;
    });
}
